import { Component, Input } from "@angular/core";

@Component({
  selector: "app-icon",
  templateUrl: "./icon.component.html",
  styleUrls: ["./icon.component.scss"],
  standalone: false,
})
export class IconComponent {
  @Input() name: string = ""; // e.g. "arrow-right", "home", "user"
  @Input() color: string = "currentColor";
  @Input() size: number = 24;
  @Input() strokeWidth: number = 2;
}
